export function toSbNav(menuMain = [], { user, business_code } = {}) {
  // Si necesitas filtrar integrationOption como hacías antes, aquí lo puedes aplicar.
  // Por ahora: respeta permition, y deja pasar integrationOption si quieres.
  const safe = (v) => (v == null ? "" : String(v));

  // Convierte una entrada de menuMain (y sus hijos, de forma recursiva) en un nodo
  // de tipo "link" (sin items) o "group" (con items -> children, que a su vez
  // pueden ser otro "group"). Esto permite anidar submenús (ej: Gestión > Mesas > Solicitudes).
  const mapItem = (opt, idx, parentId) => {
    const base = safe(opt.title).trim().toLowerCase().replace(/\s+/g, "-") || `sec-${idx}`;
    const id = parentId ? `${parentId}-${idx}-${base}` : base;

    const hasChildren = Array.isArray(opt.items) && opt.items.length > 0;

    if (!hasChildren) {
      return {
        id,
        type: "link",
        label: opt.title,
        href: opt.link || "#",
        icon: opt.icon || "fas fa-folder",
        description: opt.description,
      };
    }

    return {
      id,
      type: "group",
      label: opt.title,
      icon: opt.icon || "fas fa-folder",
      // children SOLO con permiso true
      children: opt.items
        .filter((it) => it?.permition === true)
        .map((it, j) => mapItem(it, j, id)),
    };
  };

  return [
    {
      sectionTitle: "Menú",
      items: menuMain
        .filter((opt) => opt?.permition === true)
        .map((opt, idx) => mapItem(opt, idx, null)),
    },
  ];
}